// extracted by mini-css-extract-plugin
module.exports = {"cortana":"styles_cortana__3c0lA","inner":"styles_inner__2VL39","outer":"styles_outer__oLQzr"};